<div class="undo-controls">
  <button appButton name="undo" location="annotation-controls" spacing="1" color="darker-blur" height="1"
    (click)="onHistoryChange.emit('undo')" appTooltip="Undo" tooltipKeyboardShortcut="Z" toolTipOrigin="right"
    [tooltipKeyboardShortcutMeta]="true" [class.disabled]="!canUndo">
    <app-svg src="/assets/icons/undo-upside-down.svg"></app-svg>
  </button>
  <button appButton name="redo" location="annotation-controls" spacing="1" color="darker-blur" height="1"
    (click)="onHistoryChange.emit('redo')" *ngIf="canRedo" appTooltip="Redo" tooltipKeyboardShortcut="Y"
    [tooltipKeyboardShortcutMeta]="true">
    <app-svg src="/assets/icons/redo.svg"></app-svg>
  </button>
</div>

<div class="close-button">
  <button appButton name="close" location="annotation-controls" spacing="1" color="darker-blur" height="1"
    (click)="onClose.emit()">
    <app-svg src="/assets/icons/cross.svg"></app-svg>
  </button>
</div>

<div class="annotation-controls">
  <ng-container *ngIf="bigScreen">
    <div class="button-group with-spacing">
      <button appButton name="{{_color}}" location="annotation-controls" spacing="1-5"
        [color]="color === _color ? 'white' : 'darker-blur'" height="1" *ngFor="let _color of colors"
        appTooltip="{{'label-' + _color | translate}}" [tooltipKeyboardShortcut]="shortcuts[_color]"
        (click)="switchColor(_color)">
        <app-svg src="/assets/icons/status-{{color === _color ? 'active' : 'empty'}}.svg" [attr.color]="_color">
        </app-svg>
      </button>
    </div>
    <div class="button-group with-spacing">
      <button appButton name="{{_tool}}" location="annotation-controls" spacing="1-5" *ngFor="let _tool of tools"
        appTooltip="{{'annotation-tool-' + _tool | translate}}" [tooltipKeyboardShortcut]="shortcuts[_tool]"
        [color]="tool === _tool ? 'white' : 'darker-blur'" height="1" (click)="switchTool(_tool)">
        <app-svg src="/assets/icons/annotate-{{_tool}}.svg"></app-svg>
      </button>
    </div>
  </ng-container>

  <ng-container *ngIf="!bigScreen">

    <div class="button-group with-spacing">
      <app-context-menu [options]="{width: '240px', noSpacing: true}" #colorMenu>
        <button appButton name="color-dropdown" location="annotation-controls" spacing="1" color="darker-blur" height="1" contextButton>
          <app-svg src="/assets/icons/status-active.svg" [attr.color]="color"></app-svg>
          <app-svg src="/assets/icons/24/arrow-down.svg" size="-0-5"></app-svg>
        </button>
        <div class="button-menu" contextContent>
          <app-button-menu-item name="{{_color}}" location="annotation-controls" spacing="1-5" height="1"
            *ngFor="let _color of colors" (click)="switchColor(_color); colorMenu.close()" [fullWidth]="true">
            <app-svg src="/assets/icons/status-{{color === _color ? 'active' : 'empty'}}.svg" [attr.color]="_color">
            </app-svg>
            <span>{{'label-' + _color | translate}}</span>
          </app-button-menu-item>
        </div>
      </app-context-menu>

    </div>
    <div class="button-group with-spacing">
      <app-context-menu [options]="{width: '240px', noSpacing: true}" #toolMenu>
        <button appButton name="tool-dropdown" location="annotation-controls" spacing="2" color="darker-blur-hard" height="1" weight="bold"
          [hasIcon]="true" contextButton>
          <app-svg src="/assets/icons/annotate-{{tool}}.svg"></app-svg>
          <span>{{'annotation-tool-' + tool | translate}}</span>
          <app-svg src="/assets/icons/24/arrow-down.svg" size="-0-5"></app-svg>
        </button>
        <div class="button-menu" contextContent>
          <app-button-menu-item name="{{_tool}}" location="annotation-controls" spacing="1-5" height="1"
            *ngFor="let _tool of tools" (click)="switchTool(_tool); toolMenu.close()" [fullWidth]="true"
            [color]="tool === _tool ? 'simple-primary' : 'simple'">
            <app-svg src="/assets/icons/annotate-{{_tool}}.svg">
            </app-svg>
            <span>{{'annotation-tool-' + _tool | translate}}</span>
          </app-button-menu-item>

        </div>
      </app-context-menu>
    </div>

  </ng-container>


  <div class="button-group with-spacing">
    <button appButton name="brush" location="annotation-controls" color="primary" height="1" spacing="4" (click)="done()"
      appTooltip="Send" [tooltipKeyboardShortcut]="'Enter'">
      <span [class.hidden-text]="sending">Send</span>
      <app-loading-indicator *ngIf="sending" color="white" size="small" class="button-loading-indicator">
      </app-loading-indicator>
    </button>
  </div>
</div>
